var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"type":_vm.appproperties.type,"options":{legend: {show: false}},"series":_vm.appproperties.series}})}
var staticRenderFns = []

export { render, staticRenderFns }